<template>
  <tile-grid>
    <template v-if="getService">
      <service-tile
        v-for="service in getServicesByIds(getService.childsIds)"
        :key="service.id"
        :selected="false"
        :service="service"
      />
    </template>
  </tile-grid>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ServiceTile from '@/components/services/service/ServiceTile.vue';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'Devices',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
    serviceId: {
      type: Number,
      required: false,
    },
    serviceGroupId: {
      type: Number,
      required: false,
    },
    placeId: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'getServicesByIds',
      'getServiceById',
    ]),
    getService() {
      if (this.serviceId) {
        return this.getServiceById(this.serviceId);
      }
      return null;
    },
    breadcrumbs() {
      const breadcrumbs = [];
      if (this.getService) {
        breadcrumbs.push({
          text: this.getService.name,
          to: {
            name: 'service-group',
            params: {
              placeId: this.getService.placeId,
              serviceGroupId: this.getService.groupId,
            },
          },
        });
      }
      breadcrumbs.push({
        text: this.$t('devices'),
      });
      return breadcrumbs;
    },
  },
  components: {
    TileGrid,
    ServiceTile,
  },
};
</script>

<style scoped>

</style>
